export default __webpack_public_path__ + "static/media/vasiang.87054221.avif";